export const arrToObj = (array: string[]) => {
    const tmp: {[key: string]: boolean} = {};
    array.forEach(a => {tmp[a] = false})
    return tmp
}